import React from 'react';
import Button from '../../../components/ui/Button';

const LanguageTabs = ({ activeLanguage, onLanguageChange, hasContent }) => {
  const languages = [
    { code: 'ar', label: 'العربية', flag: '🇸🇾' },
    { code: 'en', label: 'English', flag: '🇺🇸' },
    { code: 'tr', label: 'Türkçe', flag: '🇹🇷' }
  ];

  return (
    <div className="flex items-center space-x-1 bg-muted rounded-lg p-1">
      {languages?.map((language) => (
        <Button
          key={language?.code}
          variant={activeLanguage === language?.code ? 'default' : 'ghost'}
          size="sm"
          className={`relative ${
            activeLanguage === language?.code 
              ? 'bg-background text-foreground shadow-sm' 
              : 'text-muted-foreground hover:text-foreground'
          }`}
          onClick={() => onLanguageChange(language?.code)}
        >
          <span className="mr-2">{language?.flag}</span>
          <span>{language?.label}</span>
          {hasContent?.[language?.code] && (
            <div className="absolute -top-1 -right-1 w-2 h-2 bg-success rounded-full" />
          )}
        </Button>
      ))}
    </div>
  );
};

export default LanguageTabs;